var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 115,
    viewBox: "0 0 62 115"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.792 57.393c0 .051 0 .106-.007.158v.014a2.305 2.305 0 01-.712 1.538L4.389 113.889a2.352 2.352 0 01-3.261-3.391l54.944-53.1L1.128 4.288A2.359 2.359 0 011.063.962a2.388 2.388 0 011.7-.712c.61.004 1.193.244 1.63.668l56.684 54.77a2.3 2.3 0 01.712 1.538v.01c0 .055.003.106.003.157z",
    fillRule: "nonzero"
  })));
};
export default SvgRightArrow;